import { Routes, Route } from 'react-router-dom'

import LimitedFrame from '@/buyers/components/LimitedFrame'
import Order from '@/buyers/pages/LimitedOrder'
import ActivateAccount from '@/buyers/pages/ActivateAccount'
import ClaimRequired from '@/buyers/pages/LimitedClaimRequired'

const LimitedRouter = () => (
  <LimitedFrame>
    <Routes>
      <Route path="/orders/:storeOrderId/*" element={<Order />} />
      <Route path="/activate" element={<ActivateAccount />} />
      <Route path="*" element={<ClaimRequired />} />
    </Routes>
  </LimitedFrame>
)

export default LimitedRouter
